import { useQuery } from '@tanstack/vue-query';

import { computed, onMounted } from 'vue';
import type { ComputedRef } from 'vue';
import { useDark, useDocumentVisibility } from '@vueuse/core';

import { Network } from '@eaphone/network/next.ts';
import type { Service } from '@eaphone/types/resources';
import lightLogo from '@xinxiangsui/design-resource/商标/心相随/文字--彩色-浅色背景.svg';
import darkLogo from '@xinxiangsui/design-resource/商标/心相随/文字--彩色-深色背景.svg';

export function useDidShow(callback: () => void): void {
  const pageVisibility = useDocumentVisibility();

  onMounted(() => {
    if (pageVisibility.value === 'visible') {
      callback();
    }
  });
}

export function useLogo(): ComputedRef<string> {
  const isDark = useDark();

  return computed(() => (isDark.value ? darkLogo : lightLogo));
}

const defaultName: string = import.meta.env.CONFIG_NAME
  ? {
      wechat: 'xxs-wechat-wap',
      weixin: 'xxs-wechat-wap',
      webview: 'xxs-wechat-wap',
      hejia: 'hejia-app-webview',
      ehome: 'ehome-app-webview',
    }[import.meta.env.CONFIG_NAME]
  : 'xxs-wechat-wap';

async function fetchEntry(name?: string): Promise<Service> {
  return name
    ? Network.custom.get(`sales/v1/customer-service/entry/${name}/`)
    : {};
}

export function useService(name = defaultName) {
  return useQuery({
    queryKey: ['service', name],
    queryFn: () => fetchEntry(name),
  });
}
